import React from 'react';
import PropTypes from 'prop-types';
import {withFormsy, propTypes} from "formsy-react";
import {FormGroup, Label, Input, FormFeedback} from 'reactstrap';
import {FormattedMessage} from "react-intl";

export class InputFormGroup extends React.Component {
    static propTypes = {
        label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        type: PropTypes.string.isRequired,
        characterLimit: PropTypes.number,
        placeholder: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        ...propTypes
    };

    static defaultProps = {
        disabled: false
    };

    constructor(props) {
        super(props);

        this.changeValue = this.changeValue.bind(this);
    }

    changeValue(event) {
        const value = this.props.type === 'checkbox' ? event.target.checked : event.target.value;
        this.props.setValue(value);
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    }

    render() {
        const {name, id, label, type, characterLimit, getValue, showError, isPristine, showRequired, isRequired, getErrorMessage, placeholder, disabled, checked} = this.props;
        const valid = isPristine() ? undefined : (!showError() && !showRequired());

        const value = getValue() ? getValue() : '';

        return (
            <FormGroup>
                {typeof label !== "undefined" &&
                <Label className={isRequired() ? 'required' : ''} for={id}>
                    {label}
                </Label>
                }

                {typeof characterLimit !== "undefined" && characterLimit - value.length >= 0 &&
                <span className="form-limit text-muted">
                        <FormattedMessage id="form.input.limit"
                                          defaultMessage="{left, plural, one {# character} other {# characters}} left"
                                          values={{left: characterLimit - value.length}}/>
                    </span>
                }

                <Input disabled={disabled} placeholder={placeholder} valid={valid} invalid={!isPristine() && !valid} name={name} id={id} type={type} value={value} checked={checked} onChange={this.changeValue}/>

                {!isPristine() && showRequired() &&
                    <FormFeedback>
                        <FormattedMessage id="form.error.required" defaultMessage="Field is required"/>
                    </FormFeedback>
                }

                {showError() &&
                <FormFeedback>
                    {getErrorMessage()}
                </FormFeedback>
                }
            </FormGroup>
        )
    }
}

export default withFormsy(InputFormGroup);


// WEBPACK FOOTER //
// ./src/components/Form/InputFormGroup.jsx